<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="secah.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目状态" label-width='100px'>
          <el-select clearable v-model="secah.state" placeholder="请选择项目状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="进行中" :value="1"></el-option>
            <el-option label="已结束" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click='add'>添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click='fenhongShow = true'>分红</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
        <el-table-column prop="detailTitle" label="项目标题" align="center"></el-table-column>
        <el-table-column prop="projectPic" label="项目图片" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.projectPic" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="targetQuota" label="目标额度" align="center"></el-table-column>
        <el-table-column prop="targetShareBonusTicket" label="目标功绩券" align="center"></el-table-column>
        <el-table-column prop="supportShareBonusTicket" label="已支持功绩券" align="center"></el-table-column>
        <el-table-column prop="viewCount" label="观看次数" align="center"></el-table-column>
        <el-table-column prop="state" label="项目状态" align="center">
          <template slot-scope="scope">
            {{getState(scope.row.state)}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="handleType == 'add' ? '新增' : '修改'" :visible.sync="edit_add" :modal-append-to-body='false' width="800px">
      <el-form :model="handleRow" style="padding: 20px;" class="formBox">
        <el-form-item label="项目名称" label-width='100px'>
          <el-input v-model="handleRow.projectName" autocomplete="off" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目标题" label-width='100px'>
          <el-input v-model="handleRow.detailTitle" autocomplete="off" placeholder="请输入项目标题"></el-input>
        </el-form-item>
        <el-form-item label="项目图片" label-width='100px'>
          <el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'" :headers="headers" accept=".png,.jpg" :on-error='onError' :show-file-list="false" :on-success="handleAvatarSuccess">
            <img v-if="handleRow.projectPic" :src="webUrl+handleRow.projectPic" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="目标额度" label-width='100px'>
          <el-input v-model="handleRow.targetQuota" autocomplete="off" placeholder="请输入目标额度"></el-input>
        </el-form-item>
        <div data-v-eee9d61e="" class="el-form-item">
          <label class="el-form-item__label" style="width: 100px;">项目详情</label>
          <div style="margin-left: 100px;">
            <quill-editor ref="text" v-model="handleRow.detailContent" class="myQuillEditor" :options="editorOption" />
          </div>
        </div>
        <div style="text-align: right;padding: 20px;">
          <el-button @click="edit_add = false">取 消</el-button>
          <el-button type="primary" @click="sub">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="功绩云账本分红" :visible.sync="fenhongShow" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="分红总金额" label-width='120px'>
          <el-input type="text" v-model="shareBonusAmount" maxlength="10" autocomplete="off" placeholder="请输入分红总金额">
          </el-input>
        </el-form-item>
        <el-form-item label="分红密码" label-width='120px'>
          <el-input type="password" v-model="password" maxlength="10" autocomplete="off" placeholder="请输入分红密码">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fenhongShow = false">取 消</el-button>
        <el-button type="primary" @click="fenhong()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import quillConfig from './quill-config.js'

const defaultRowQuery = {
  projectName: '',
  detailTitle: '',
  projectPic: '',
  targetQuota: '',
  detailContent: '',
}
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      secah: {
        pageSize: 10,
        pageNum: 1,
        projectName: '',
        state: '',
      },
      edit_add: false,
      handleType: '',
      handleRow: Object.assign({}, defaultRowQuery),
      headers: {
        token: this.$store.state.token,
      },
      editorOption: quillConfig,
      fenhongShow: false,
      password: '',
      shareBonusAmount: '',
    }
  },
  components: {
    quillEditor,
  },
  created() {
    this.getList()
  },
  methods: {
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      this.getList()
    },
    getState(state) {
      if (state == 1) {
        return '进行中'
      } else if (state == 2) {
        return '已结束'
      }
    },
    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getList()
    },
    //获取数据
    getList() {
      var secah = this.secah
      this.httpGet('/admin/physicalCloudLedger/projectList', secah, true).then(
        (res) => {
          if (res.code == 200) {
            this.tableData = res.data.list
            this.total = res.data.total
          }
        }
      )
    },
    fenhong() {
      if(!this.password || !this.shareBonusAmount) {
        this.$message.error('请完善信息')
        return
      }
      let params = {
        password: this.password,
        shareBonusAmount: this.shareBonusAmount
      }
      this.$confirm('确定分红吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/admin/physicalCloudLedger/shareOutBonus', params, true, {'Content-Type':'application/json'}
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('分红成功')
            }
          })
        })
        .catch(() => {})
    },
    add() {
      this.edit_add = true
      this.handleType = 'add'
      this.handleRow = Object.assign({}, defaultRowQuery)
    },
    edit(row) {
      this.edit_add = true
      this.handleType = 'edit'
      this.handleRow = JSON.parse(JSON.stringify(row))
    },
    onError() {
      this.$message.error('上传失败')
    },
    //上传图片回调
    handleAvatarSuccess(res, file) {
      this.handleRow.projectPic = res.data.path
      console.log(this.handleRow)
    },
    sub() {
      if (
        !this.handleRow.projectName ||
        !this.handleRow.detailTitle ||
        !this.handleRow.projectPic ||
        !this.handleRow.targetQuota ||
        !this.handleRow.detailContent
      ) {
        this.$message.error('请完善信息')
        return
      }
      this.httpPost('/admin/physicalCloudLedger/saveOrUpdateProject', this.handleRow, true, {
        'Content-Type': 'application/json'
      }).then((res) => {
          if (res.code == 200) {
            this.$message.success('操作成功')
            this.getList();
            this.edit_add = false
          }
        }
      )
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
